import React from 'react';

import { StressTestMatrix } from '@/shared/api/borrow';
import { formatPercentage } from '@/shared/utils/helpers';
import { AssetWithIcon } from '@/shared/ui';

interface AllowedProps {
    tokens: StressTestMatrix[];
}

export const Allowed: React.FC<AllowedProps> = ({ tokens }) => {
    const safeTokens = Array.isArray(tokens) ? tokens : [];

    return (
        <div className='flex flex-col items-start w-full overflow-x-auto bg-primary'>
            <table className='table-auto w-full border-collapse bg-primary border border-border'>
                <thead>
                    <tr className='border-b border-border h-[52px]'>
                        <th className='font-normal text-left text-primary-content bg-secondary pr-4 pl-7 py-2'>
                            Assets
                        </th>
                        <th className='font-normal text-left text-primary-content bg-secondary px-4 py-2'>
                            Stress Tested
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {safeTokens.map((item, key) => (
                        <tr key={key} className='border-b border-border hover:bg-secondary/10'>
                            <td className='px-6 py-4'>
                                <AssetWithIcon
                                    assetName={item.symbol as string}
                                    data-testid={`details-allowed-icon-${item.symbol}-${key}`}
                                    className='[&_div]:text-[14px]'
                                />
                            </td>
                            <td
                                className='px-6 py-4'
                                data-testid={`details-allowed-stress-tested-${key}`}
                            >
                                {`-${formatPercentage(item.percent)}%`}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
